import axios from "axios";
import {
    ALL_BANNERS_FAIL,
    ALL_BANNERS_REQUEST,
    ALL_BANNERS_SUCCESS,
    ADMIN_BANNERS_FAIL,
    ADMIN_BANNERS_REQUEST,
    ADMIN_BANNERS_SUCCESS,
    CLEAR_ERRORS,
    DELETE_BANNER_FAIL,
    DELETE_BANNER_REQUEST,
    DELETE_BANNER_SUCCESS,
    NEW_BANNER_FAIL,
    NEW_BANNER_REQUEST,
    NEW_BANNER_SUCCESS
} from "../constants/bannerConstants";

// Get All Banners
export const getBanners = () => async (dispatch) => {
    try {
        dispatch({ type: ALL_BANNERS_REQUEST });

        const { data } = await axios.get("/api/v1/banners");

        dispatch({
            type: ALL_BANNERS_SUCCESS,
            payload: data.banners,
        });
    } catch (error) {
        dispatch({
            type: ALL_BANNERS_FAIL,
            payload: error.response.data.message,
        });
    }
};

// Get All Banners ---ADMIN
export const getAdminBanners = () => async (dispatch) => {
    try {
        dispatch({ type: ADMIN_BANNERS_REQUEST });

        const { data } = await axios.get('/api/v1/admin/banners');

        dispatch({
            type: ADMIN_BANNERS_SUCCESS,
            payload: data.banners,
        });

    } catch (error) {
        dispatch({
            type: ADMIN_BANNERS_FAIL,
            payload: error.response.data.message,
        });
    }
};

// New Banner ---ADMIN
export const createBanner = (bannerData) => async (dispatch) => {
    console.log("Banner Data being sent:", bannerData);
    try {
        dispatch({ type: NEW_BANNER_REQUEST });

        const config = {};

        const { data } = await axios.post(
            `/api/v1/admin/banner/new`,
            bannerData,
            config
        );

        dispatch({
            type: NEW_BANNER_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: NEW_BANNER_FAIL,
            payload: error.response.data.message,
        });
    }
};

// Delete Banner ---ADMIN
export const deleteBanner = (id) => async (dispatch) => {
    try {
        dispatch({ type: DELETE_BANNER_REQUEST });

        const { data } = await axios.delete(`/api/v1/admin/banner/${id}`);

        dispatch({
            type: DELETE_BANNER_SUCCESS,
            payload: data.success,
        });

    } catch (error) {
        dispatch({
            type: DELETE_BANNER_FAIL,
            payload: error.response.data.message,
        });
    }
};


// Clear All Errors
export const clearErrors = () => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
};